import React from 'react';
import classNames from 'classnames';
import './index.less';

const Icon = ({ children, value = null, title = null, visible = true, className, noMargin = false }) => {
    if (!visible) return null;
    const iconClass = value?.startsWith('icon-svg-') ? value : `icon-svg-${value}`;
    return <span className={classNames('icon', iconClass, className, {
        'no-margin': noMargin,
    })} title={title}>{children}</span>;
};

export default Icon;
